import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '../theme';

export function SvgStar(props) {
  const theme = useTheme();
  const { width = '24px', height = '24px', stroke = theme.colors.primary, fill } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" version="1.1">
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g stroke={stroke}>
          <g transform="translate(7.000000, 7.000000)">
            <g>
              <polygon
                fill={fill ? stroke : ''}
                points="5.09090879 0.242424228 6.58909052 3.27757556 9.93939335 3.7672725 7.51515107 6.12848448 8.08727225 9.46424186 5.09090879 7.88848438 2.09454533 9.46424186 2.66666651 6.12848448 0.242424228 3.7672725 3.59272706 3.27757556"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

SvgStar.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  stroke: PropTypes.string,
  fill: PropTypes.bool,
};
